export default __webpack_public_path__ + "static/media/dollarsign.af78212f.svg";